import { render, staticRenderFns } from "./PickupTypeLabel.vue?vue&type=template&id=0fc9c808&scoped=true"
import script from "./PickupTypeLabel.vue?vue&type=script&lang=ts"
export * from "./PickupTypeLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc9c808",
  null
  
)

export default component.exports